import { render } from "./NotesGeneral.vue?vue&type=template&id=42cdb31f&scoped=true"
import script from "./NotesGeneral.vue?vue&type=script&lang=js"
export * from "./NotesGeneral.vue?vue&type=script&lang=js"

import "./NotesGeneral.vue?vue&type=style&index=0&id=42cdb31f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cdb31f"]])

export default __exports__